'use strict';

angular.module('programme')

.component('articlePage', {
    controller: 'ArticlePageCtrl',
    templateUrl: 'modules/programme/components/articlePage.html',
    bindings: {
        model: '<'
    }
})

.controller('ArticlePageCtrl', function (programmeEditorOptions, kdGate, editorState, linkModal)
{
    this.editorOptions = programmeEditorOptions;
    this.editorState = editorState;

    this.editorState.editMode = false;
    this.editorOptions.controls = kdGate.check('admin');

    this.editorOptions.onCreateLink = linkModal.open;
    this.editorOptions.onClickLink = linkModal.click;
});
